import { render, staticRenderFns } from "./Storelist.vue?vue&type=template&id=24e5e82e&scoped=true&"
import script from "./Storelist.vue?vue&type=script&lang=js&"
export * from "./Storelist.vue?vue&type=script&lang=js&"
import style0 from "./Storelist.vue?vue&type=style&index=0&id=24e5e82e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e5e82e",
  null
  
)

export default component.exports